import _regeneratorRuntime from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createForOfIteratorHelper from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { ParticlesInteractorBase } from "../../../Core";
import { getDistances } from "../../../Utils";
export var Attractor = /*#__PURE__*/function (_ParticlesInteractorB) {
  _inherits(Attractor, _ParticlesInteractorB);

  var _super = _createSuper(Attractor);

  function Attractor(container) {
    _classCallCheck(this, Attractor);

    return _super.call(this, container);
  }

  _createClass(Attractor, [{
    key: "interact",
    value: function () {
      var _interact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(p1) {
        var _a, container, distance, pos1, query, _iterator, _step, p2, pos2, _getDistances, dx, dy, rotate, ax, ay, p1Factor, p2Factor;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = this.container, distance = (_a = p1.retina.attractDistance) !== null && _a !== void 0 ? _a : container.retina.attractDistance, pos1 = p1.getPosition(), query = container.particles.quadTree.queryCircle(pos1, distance);
                _iterator = _createForOfIteratorHelper(query);
                _context.prev = 2;

                _iterator.s();

              case 4:
                if ((_step = _iterator.n()).done) {
                  _context.next = 15;
                  break;
                }

                p2 = _step.value;

                if (!(p1 === p2 || !p2.options.move.attract.enable || p2.destroyed || p2.spawning)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("continue", 13);

              case 8:
                pos2 = p2.getPosition(), _getDistances = getDistances(pos1, pos2), dx = _getDistances.dx, dy = _getDistances.dy, rotate = p1.options.move.attract.rotate, ax = dx / (rotate.x * 1000), ay = dy / (rotate.y * 1000), p1Factor = p2.size.value / p1.size.value, p2Factor = 1 / p1Factor;
                p1.velocity.x -= ax * p1Factor;
                p1.velocity.y -= ay * p1Factor;
                p2.velocity.x += ax * p2Factor;
                p2.velocity.y += ay * p2Factor;

              case 13:
                _context.next = 4;
                break;

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](2);

                _iterator.e(_context.t0);

              case 20:
                _context.prev = 20;

                _iterator.f();

                return _context.finish(20);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 17, 20, 23]]);
      }));

      function interact(_x) {
        return _interact.apply(this, arguments);
      }

      return interact;
    }()
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      return particle.options.move.attract.enable;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }]);

  return Attractor;
}(ParticlesInteractorBase);